"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiKeyDetails = exports.ApiKey = exports.ApiKeyId = void 0;
const zod_1 = require("zod");
/**
 * Passed in the jti claim of the JWT API key, this uniquely identifies the specific API key
 */
exports.ApiKeyId = zod_1.z.string().uuid();
/**
 * An API key is a standard JWT-formatted string - we don't validate any claims or headers here, just the format
 */
exports.ApiKey = zod_1.z.string().regex(/^(?:[\w-]*\.){2}[\w-]*$/);
/**
 * Persisted details for each generated API key
 */
exports.ApiKeyDetails = zod_1.z.object({
    id: exports.ApiKeyId,
    createdAt: zod_1.z.number().min(1700000000000).safe().finite().int(),
});
//# sourceMappingURL=api.js.map